/* eslint-disable @typescript-eslint/naming-convention */
import { Menu } from '@mui/material';

import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import { ITopUps } from '@/modules/credits/models/top-ups';
import { TableRowStyled } from '@styled/table-row.styled';
import JTableCell from '@atoms/JTabelCell';
import { ShowMoreButton } from '@atoms/ShowMoreButton';
import { MenuItemStyled } from '@styled/menu-item.styled';
import moment from 'moment';
import ConfirmCancelPopUps from '../../molecules/ConfirmCancelPopUps';
import useJDialog from '@/hooks/useJDialog';
import { useCancelTopUp } from '@/modules/credits/queries';
import useJSnackbar from '@/hooks/useJSnackbar';
import { useNavigate } from 'react-router-dom';
import Paths from '@/routes/paths';

interface Props {
  row: ITopUps;
}

const TopUpsRow = ({ row }: Props) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { showJDialog, closeJDialog } = useJDialog();
  const { showSnackbar } = useJSnackbar();

  const {
    creditTopup_id,
    enterprise_name,
    creditTopup_euros_amount,
    creditTopup_credits_amount,
    establishmentscount,
    creditTopup_created_at,
  } = row;

  const [rowMenuanchorEl, setRowMenuAnchorEl] = useState<null | HTMLElement>(
    null,
  );
  const open = Boolean(rowMenuanchorEl);
  const { mutate, isError } = useCancelTopUp();
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setRowMenuAnchorEl(event.currentTarget);
  };
  const handleRowMenuClose = () => {
    setRowMenuAnchorEl(null);
  };

  useEffect(() => {
    if (isError) {
      showSnackbar(t('API_ERROR'), 'error');
    }
  }, [isError]);

  const onClickCancelTopUps = () => {
    showJDialog(
      t('CANCEL_POP_UPS'),
      <ConfirmCancelPopUps
        onCancel={() => {
          mutate(creditTopup_id);
          closeJDialog();
        }}
        onClose={closeJDialog}
      />,
    );
    handleRowMenuClose();
  };

  return (
    <TableRowStyled
      key={creditTopup_id}
      data-test={`user-list-row-${enterprise_name}-${creditTopup_euros_amount}-${creditTopup_credits_amount}`}
    >
      <JTableCell isbold>{enterprise_name}</JTableCell>
      <JTableCell>{`${creditTopup_euros_amount} €`}</JTableCell>
      <JTableCell>{creditTopup_credits_amount}</JTableCell>
      <JTableCell>{establishmentscount}</JTableCell>
      <JTableCell>
        {moment(creditTopup_created_at).format('DD/MM/YYYY')}
      </JTableCell>
      <JTableCell>
        <ShowMoreButton onClick={handleClick} open={open} />
        <Menu
          id="basic-menu"
          anchorEl={rowMenuanchorEl}
          open={open}
          onClose={handleRowMenuClose}
          MenuListProps={{
            'aria-labelledby': 'basic-button',
          }}
        >
          <MenuItemStyled
            data-qa="go-to-top-up-details"
            onClick={() =>
              navigate(Paths.DetailsTopUps.replace(':id', creditTopup_id))
            }
          >
            {t('SEE_DETAILS')}
          </MenuItemStyled>
          {establishmentscount === '0' && (
            <MenuItemStyled
              data-qa="cancel-top-up"
              red
              onClick={onClickCancelTopUps}
            >
              {t('CANCEL_TOP_UPS')}
            </MenuItemStyled>
          )}
        </Menu>
      </JTableCell>
    </TableRowStyled>
  );
};

export default TopUpsRow;
